<template>
  <footer class="footer mt-auto py-3 ">
    <router-link class="btn btn-primary btn-help" :to="{ name: 'help'}" title="Hilfe aufrufen"><icon icon="question-circle" /></router-link>
    <nav class="nav">
      <router-link class="nav-link" :to="{ name: 'impressum'}">Impressum</router-link>
      <a class="nav-link" target= blank href="https://www.admin.ch">admin.ch</a>
      <a class="nav-link" target= blank href="https://www.ch.ch">ch.ch</a>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
  footer .btn-help{
    position: fixed;
    bottom: 40px;
    right: 40px;
    border-radius: 100px;
    width: 60px;
    height: 60px;
    line-height: 40px;
    font-size: 30px;
    z-index: 1001;
    font-weight: bold;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);
  }

  footer.footer {
    background-color: #f5f5f5;
    height: 70px;
  }
</style>
